import { isServer } from 'lit';
import { getRandomNumber } from '../get-random-number/get-random-number.js';

class LightDomSlotFallbackController {
  constructor(host, slots) {
    this._slotIds = [];
    this._slots = [];
    this._host = host;
    this._slots = slots;
    this._slotIds = slots.map(() => getRandomNumber().toString());
  }
  setFallbackSlotsContent() {
    if (isServer) {
      return;
    }
    this._slots.forEach(this._setFallbackSlotContent.bind(this));
  }
  _setFallbackSlotContent(slot, index) {
    const { fallbackElement, override, slotName } = slot();
    const id = this._slotIds[index];
    const fallbackElementId = `_${id}`;
    const existingFallbackElement = this._host.querySelector?.(`#${fallbackElementId}`);
    const existingElementsOfSlot = this._host.querySelector?.(`[slot="${slotName}"]`);
    if (existingElementsOfSlot && override) {
      existingElementsOfSlot.remove();
    }
    const fallbackElementInstance = fallbackElement();
    fallbackElementInstance.id = fallbackElementId;
    fallbackElementInstance.slot = slotName;
    if (existingFallbackElement) {
      existingFallbackElement.remove();
    }
    this._host.appendChild(fallbackElementInstance);
  }
}

export { LightDomSlotFallbackController };
